import DialogModalContent from '@/features/shared/DialogModalContent';
import { MuiButton, MuiTypography } from '@/features/shared/material-ui';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {},
    dialogContent: {
      backgroundColor: 'white',
      padding: '20px 30px',
      width: '80vw',
      [muiTheme.breakpoints.up('sm')]: {
        width: '400px',
      },
    },
    buttonSection: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '10px',
    },
    bodyContent: {
      marginBottom: '20px',
    },
    headerContent: {
      marginBottom: '10px',
    },
  }),
  { name: 'ConfirmDialog' },
);

export interface ConfirmDialogContent {
  isOpen: boolean;
  header?: string;
  description?: string;
  cancelButtonLabel?: string;
  confirmButtonLabel?: string;
  accept?: () => void;
  reject?: () => void;
}

const ConfirmDialog = ({
  isOpen = false,
  header = '',
  description = '',
  reject = () => {},
  accept = () => {},
  confirmButtonLabel = 'Confirm',
  cancelButtonLabel = 'Cancel',
}: ConfirmDialogContent) => {
  const classes = useStyles();

  return (
    <DialogModalContent isOpen={isOpen} keepMounted={false}>
      <div className={classes.dialogContent}>
        {!!header && (
          <MuiTypography variant="h5" component="h5" className={classes.headerContent}>
            {header}
          </MuiTypography>
        )}
        {!!description && (
          <div className={classes.bodyContent}>
            <MuiTypography>{description}</MuiTypography>
          </div>
        )}
        {(!!cancelButtonLabel || !!confirmButtonLabel) && (
          <div className={classes.buttonSection}>
            {!!cancelButtonLabel && (
              <MuiButton variant="text" color="secondary" onClick={reject}>
                {cancelButtonLabel ?? ''}
              </MuiButton>
            )}
            {!!confirmButtonLabel && (
              <MuiButton variant="contained" color="secondary" onClick={accept}>
                {confirmButtonLabel ?? ''}
              </MuiButton>
            )}
          </div>
        )}
      </div>
    </DialogModalContent>
  );
};

export default React.memo(ConfirmDialog);
